import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { XsellUpsellPage } from './xsell-upsell';

@NgModule({
  declarations: [
    XsellUpsellPage,
  ],
  imports: [
    IonicPageModule.forChild(XsellUpsellPage),
  ],
})
export class XsellUpsellPageModule {}



// WEBPACK FOOTER //
// ./src/pages/xsell-upsell/xsell-upsell.module.ts